import {
  EventBus, PDFFindController, PDFHistory, PDFLinkService,
} from 'pdfjs-dist/legacy/web/pdf_viewer';
import CustomPdfViewer from './customPdfViewer';

export class PdfViewerFactory {
  eventBus = new EventBus();

  pdfLinkService = new PDFLinkService({
    externalLinkTarget: 2, // LinkTarget value from in dom_utils (PDF.js)
    eventBus: this.eventBus,
    ignoreDestinationZoom: true,
  });

  baseOptions = {
    linkService: this.pdfLinkService,
    eventBus: this.eventBus,
  };

  pdfHistory = new PDFHistory(this.baseOptions);

  pdfFindController = new PDFFindController(this.baseOptions);

  constructor({ container, viewer }) {
    this.pdfLinkService.setHistory(this.pdfHistory);

    this.pdfViewer = new CustomPdfViewer({
      container,
      viewer,
      findController: this.pdfFindController,
      enablePrintAutoRotate: true,
      ...this.baseOptions,
    });

    this.pdfLinkService.setViewer(this.pdfViewer);
  }
}
